import type { ReactNode } from "react";

interface DashboardRowTimeValueProps {
  label: ReactNode;
  children: ReactNode;
  displayAsError?: boolean | undefined;
}

export function ShipmentRowTimeValue(props: DashboardRowTimeValueProps) {
  const descriptionColor = props.displayAsError
    ? "text-red"
    : "text-foreground";
  return (
    <div className="flex flex-col flex-nowrap items-start">
      <div className="text-[10px] font-light text-content-muted">
        {props.label}
      </div>
      <div className={`text-[14px] font-medium ${descriptionColor}`}>
        {props.children}
      </div>
    </div>
  );
}
